import ScopeConstants from "constants/ScopeConstants"

export const ChargeRateListScope = {
    key: ScopeConstants.CHARGE_RATE_LIST,
    selector: (state) => state.chargeRateList,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/ChargeRateList/Standard/Rates/",
    updateEndpoint: "/api/ChargeRate/Update/",
    deleteEndpoint: "/api/ChargeRate/Delete/"
}